import usePageTitle from "common/hooks/usePageTitle";

export default function PageTitle({ children }: { children?: string }) {
  const pageTitle = usePageTitle();

  return (
    <h1 className="text-md-bold lg:text-lg-bold">{children || pageTitle}</h1>
  );
}
